import { api } from "../configs/axiosConfig"

export const ConversationAPI = {
  startConversation: async function () {
    if(!window.localStorage.getItem('password')) {
      return '';
    }

    const password = window.localStorage.getItem('password');
    
    const response = await api.request({
      method: "POST",
      url: "/integration/api/conversation",
      auth: {
        username: "licowebapp",
        password: password
      },
    })

    return response.data.id
  },
}